export class UserItem {
  public id: number;
  public email: string;
  public isActive: boolean;
  public isClient: boolean;
  public name: string;
  public clients: Array<number>;
  public roles: Array<string>;
  public status: string;

  /** @ngInject */
  constructor(userItem: any) {
    this.id = userItem.id || "";
    this.email = userItem.email;
    this.isActive = userItem.isActive;
    this.name = userItem.name;
    this.clients = userItem.clients;
    this.roles = userItem.roles;
    this.status = userItem.status;
  }
}




// WEBPACK FOOTER //
// ./src/app/users/UserItem.ts